jQuery(function($){

    let available_city = [];

    $('.modal-ville[data-ville]').each(function(){
        available_city.push($(this).attr('data-ville'));
    });
    
    available_city.forEach(function(element){
        $('path[data-ville="' + element + '"]').addClass('has-modal');
    });

    $('path[data-ville]').on('click', function(e){
        e.preventDefault();

        if(!$(this).hasClass('has-modal')) {
            return false;
        }

        let path_ville = $(this).attr('data-ville');

        $('.modal-ville.active').removeClass('active');

        $('.modal-ville[data-ville="' + path_ville + '"]').addClass('active');
    });

    $('path[data-ville]').on('mouseenter', function(e){
        e.preventDefault();

        if(!$(this).hasClass('has-modal')) {
            return false;
        }

        let path_ville = $(this).attr('data-ville');

        $('text[data-ville="' + path_ville + '"]').addClass('active');
        $('tspan[data-ville="' + path_ville + '"]').addClass('active');
    });

    $('path[data-ville]').on('mouseleave', function(e){
        e.preventDefault();

        if(!$(this).hasClass('has-modal')) {
            return false;
        }

        let path_ville = $(this).attr('data-ville');

        $('text[data-ville="' + path_ville + '"]').removeClass('active');
        $('tspan[data-ville="' + path_ville + '"]').removeClass('active');
    });

    $('.modal-ville .modal-ville__close').on('click', function(e){
        e.preventDefault();

        if(!$(this).parents('.modal-ville').hasClass('active')) {
            return false;
        }
        
        $(this).parents('.modal-ville').removeClass('active');
    });
    
});